"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationAction = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("@dp-instant/utils");
var core_1 = require("@dp-instant/core");
var inversify_1 = require("inversify");
var interfaces_1 = require("@dp-instant/interfaces");
var NotificationAction = (function (_super) {
    tslib_1.__extends(NotificationAction, _super);
    function NotificationAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.action = "CUSTOM";
        _this.template = "play_turn";
        _this.notification = "PUSH";
        return _this;
    }
    NotificationAction_1 = NotificationAction;
    NotificationAction.prototype.execute = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload, result, image, el_1, notificationDiv, interval_1, removeEl, text;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.data = data;
                        return [4, this.getPayload()];
                    case 1:
                        payload = _a.sent();
                        return [4, this.social.notify(payload)];
                    case 2:
                        result = _a.sent();
                        if (result) {
                            utils_1.log.trace("notification", payload.text, payload.strategy);
                            if (process.env.NODE_ENV === "development") {
                                image = new Image();
                                image.crossOrigin = "Anonymous";
                                image.src = payload.image;
                                image.style.width = "100%";
                                el_1 = document.createElement("div");
                                el_1.style.width = "100%";
                                el_1.style.position = "absolute";
                                el_1.style.zIndex = "1000";
                                notificationDiv = document.createElement("div");
                                removeEl = function () {
                                    clearInterval(interval_1);
                                    document.body.removeChild(el_1);
                                };
                                el_1.onclick = removeEl;
                                text = document.createElement("div");
                                notificationDiv.style.margin = "5px 5px 5px auto";
                                notificationDiv.style.opacity = "0.5";
                                notificationDiv.style.padding = "10px";
                                notificationDiv.style.borderRadius = "10px";
                                notificationDiv.style.border = "1px solid #999";
                                notificationDiv.style.background = "#f1f1f1";
                                notificationDiv.style.right = "0";
                                notificationDiv.style.width = "40%";
                                notificationDiv.style.maxWidth = "300px";
                                text.style.margin = "auto";
                                text.innerText = (function (text, locale) {
                                    if (typeof text === "object") {
                                        return (text.localizations[locale] ||
                                            text.default);
                                    }
                                    return "" + text;
                                })(payload.text, this.social.locale);
                                notificationDiv.appendChild(image);
                                notificationDiv.appendChild(text);
                                el_1.appendChild(notificationDiv);
                                document.body.insertBefore(el_1, document.body.firstChild);
                                interval_1 = setTimeout(removeEl, 1000);
                            }
                        }
                        else {
                            utils_1.log.warn("notification", payload.text, payload.strategy);
                        }
                        return [2];
                }
            });
        });
    };
    NotificationAction.prototype.getPayload = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {
                            action: this.action,
                            template: this.template,
                            strategy: this.strategy,
                            notification: this.notification,
                            cta: this.cta,
                            text: this.getText()
                        };
                        return [4, this.getImage()];
                    case 1: return [2, (_a.image = _b.sent(),
                            _a)];
                }
            });
        });
    };
    NotificationAction.prototype.getEmoji = function () {
        return NotificationAction_1.EMOJI ? NotificationAction_1.EMOJI + " " : "";
    };
    NotificationAction.prototype.getI18NKey = function () {
        return "play_turn";
    };
    NotificationAction.prototype.getText = function () {
        var _this = this;
        var emoji = this.getEmoji();
        var replaceUsernameAndScore = function (str) {
            return emoji +
                str.replace(/{username}|{score}/g, function (key) {
                    switch (key) {
                        case "{username}":
                            return _this.social.me.name;
                        case "{score}":
                            return "" + _this.social.me.scoreSession;
                    }
                    return key;
                });
        };
        var transform = function (str, fn) {
            var obj = {
                default: fn(str.default),
                localizations: {}
            };
            for (var key in str.localizations) {
                obj.localizations[key] = fn(str.localizations[key]);
            }
            return obj;
        };
        return transform(this.i18n[this.getI18NKey()], replaceUsernameAndScore);
    };
    NotificationAction.prototype.getImage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, this.loadImage("./assets/Notification.png")];
            });
        });
    };
    NotificationAction.prototype.loadImage = function (path, cache) {
        if (cache === void 0) { cache = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (cache && NotificationAction_1.IMAGES_CACHE[path]) {
                    return [2, NotificationAction_1.IMAGES_CACHE[path]];
                }
                return [2, new Promise(function (resolve) {
                        var image = new Image();
                        image.crossOrigin = "Anonymous";
                        image.src = path;
                        image.style.visibility = "hidden";
                        document.body.appendChild(image);
                        image.addEventListener("load", function () {
                            document.body.removeChild(image);
                            var canvas = document.createElement("canvas");
                            var ctx = canvas.getContext("2d");
                            canvas.width = image.width;
                            canvas.height = image.height;
                            ctx.drawImage(image, 0, 0);
                            var imageBase64String = canvas.toDataURL("image/jpeg");
                            if (cache) {
                                NotificationAction_1.IMAGES_CACHE[path] = imageBase64String;
                            }
                            resolve(imageBase64String);
                        });
                    })];
            });
        });
    };
    var NotificationAction_1;
    NotificationAction.IMAGES_CACHE = {};
    NotificationAction.EMOJI = "";
    NotificationAction.WIDTH_FULL = 1200;
    NotificationAction.HEIGHT_FULL = 627;
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.model),
        tslib_1.__metadata("design:type", Object)
    ], NotificationAction.prototype, "social", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesNotification.i18n),
        tslib_1.__metadata("design:type", Object)
    ], NotificationAction.prototype, "i18n", void 0);
    NotificationAction = NotificationAction_1 = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], NotificationAction);
    return NotificationAction;
}(core_1.Action));
exports.NotificationAction = NotificationAction;
//# sourceMappingURL=NotificationAction.js.map